import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TextField, CircularProgress, MuiThemeProvider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as actions from 'components/TrustCenter/store/actions';
import { isBlank, isNotBlank } from 'components/Common/Utils/StringUtils';
import { FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME } from 'components/TrustCenter/TrustCenterMuiTheme';
import { SPINNER_THEME } from 'components/TrustCenter/VisibilityConnection/ConnectionWizard/AddConnectionMUITheme';
import ClearIcon from '@material-ui/icons/Clear';

const ProviderSearch = (props) => {
    const {
        selectedAccountType,
        isProviderAccountsLoaded,
        providers,
        getProviderAccounts,
        session,
        sendSelectedProvider,
        sendSelectedProviderAccountId
    } = props;

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    const [userInput, setUserInput] = useState('');

    useEffect(() => {
        if (isNotBlank(selectedAccountType)) {
            setOptions([]);
            getProviderAccounts(selectedAccountType, '', session);
        }
        setUserInput('');
    }, [selectedAccountType]);

    useEffect(() => {
        if (isProviderAccountsLoaded) {
            setOptions([...providers]);
        }
    }, [isProviderAccountsLoaded]);

    const handleSelectedOption = (selectedOption, reason) => {
        if (reason === 'select-option') {
            setUserInput(selectedOption.name);
            sendSelectedProvider(selectedOption.objectId);
            sendSelectedProviderAccountId(selectedOption?.id);
        } else {
            sendSelectedProvider('');
            sendSelectedProviderAccountId('');
        }
    };

    return (
        <MuiThemeProvider theme={FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME}>
            <Autocomplete
                id="provider-name"
                open={open}
                inputValue={userInput}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                getOptionSelected={(option, value) => option.name === value.name}
                getOptionLabel={(option) => option.name}
                options={options}
                loading={!isProviderAccountsLoaded}
                loadingText={
                    <MuiThemeProvider theme={SPINNER_THEME}>
                        <CircularProgress />
                    </MuiThemeProvider>
                }
                clearOnBlur={false}
                disabled={isBlank(selectedAccountType)}
                noOptionsText="(No record found)"
                onChange={(event, selectedOption, reason) =>
                    handleSelectedOption(selectedOption, reason)
                }
                closeIcon={
                    <ClearIcon
                        onClick={() => {
                            setUserInput('');
                        }}
                        fontSize="small"
                    />
                }
                renderInput={(params) => (
                    <TextField
                        margin="normal"
                        {...params}
                        label="Provider Name *"
                        variant="filled"
                        helperText={' '}
                        onChange={(event) => {
                            setUserInput(event.target.value);
                        }}
                    />
                )}
            />
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state) => {
    return {
        session: state.session.sessionValue,
        providers: state.connection.providers,
        selectedAccountType: state.connection.selectedAccountType,
        isProviderAccountsLoaded: state.connection.isProviderAccountsLoaded
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProviderAccounts: (selectedAccountType, searchQuery, session) =>
            dispatch(actions.getProviderAccounts(selectedAccountType, searchQuery, session))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProviderSearch));
